import React, { useEffect } from "react";

import PluginLoader from "@views/plugins/PluginLoader";

const PLUGIN_KEY = "sy_orbitalid_manager";

export default function OrbitalIdManager() {
  useEffect(() => {
    PluginLoader(PLUGIN_KEY);
  }, [])

  return (
    <div id={PLUGIN_KEY}> </div>
  );
}

